import { combineReducers } from 'redux';

import accuclaimEdit from './report/reducer';

export default combineReducers({
  accuclaimEdit,
});



// WEBPACK FOOTER //
// ./src/pages/accuclaimedit/state/reducer.js